import VuiSelect from "components/VuiSelect";
import { Grid } from "@mui/material";

export function AppCodesFilterState({ filterStateSelect, fetchPromoCodes }) {
  const handleFilter = (e) => {
    const { value } = e;
    fetchPromoCodes({ key: "used", value, clear: value === "" });
  };
  return (
    <Grid
      item
      xs={12}
      md={4}
      xl={3}
      sx={{ padding: "16px 16px 0px 16px", marginTop: "auto", marginLeft: "auto" }}
    >
      <VuiSelect
        onChange={handleFilter}
        placeholder={filterStateSelect.placeholder}
        options={filterStateSelect.options}
      />
    </Grid>
  );
}
